// This is an utility function to return refs that allows mocking for unit testing
export const refCaller = <T>(ref: React.MutableRefObject<T>): T => {
	return ref.current;
};
